export const parsePhoneNumber = (phone: string) => {
  return phone?.replace(/[()_-\s]/g, "")
}
